import Modal from '../../components/reactModal'

const ConfirmationModal = (props) => {
  return (
    <Modal className='confirmation-modal' isOpen={props.enableModal} onClose={props.onClose}>
      {
        props.showError ? (
          <div className='alert alert-danger'>
            {props.errorMessage ? props.errorMessage : 'Something went wrong, please try it again later.'}
          </div>
        ) : null
      }
      <h3 className='confirmation-modal_title'>{ props.title }</h3>
      <div className='confirmation-modal_message'>{props.message}</div>
      <div className='confirmation-modal_buttons'>
        {
          props.buttons.map(button => {
            return <button
              onClick={button.callback}
              className={`${button.class} ${props.isLoading && button.showLoading ? 'is--loading' : ''}`}
            >
              {
                button.showLoading
                  ? <div>
                    <div className='btn--loader' />
                    <span className='btn__hide-when-loading'>{button.text}</span>
                  </div>
                  : button.text
              }
            </button>
          })
        }
      </div>
    </Modal>
  )
}

export default ConfirmationModal
